<prizm-doc-page class="info-page" header="Дорожная карта и задачи">
  <p>
    Сейчас мы работаем над интеграцией github и jira. После завершения работы в GitHub будет доступна дорожная
    карта <a href="https://github.com/orgs/zyfra/projects/1">по этой ссылке</a>.
  </p>
</prizm-doc-page>
